import React from 'react';
import Joyride, { CallBackProps, EVENTS, STATUS } from 'react-joyride';
import { useOnboarding } from '../contexts/OnboardingContext';

const OnboardingGuide: React.FC = () => {
  const { isGuideActive, stopGuide, stepIndex, setStepIndex, steps } = useOnboarding();

  const handleJoyrideCallback = (data: CallBackProps) => {
    console.log('OnboardingGuide: Callback received:', data);
    const { status, index, type } = data;
    
    if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      console.log('OnboardingGuide: Guide finished or skipped');
      stopGuide();
    } else if (type === EVENTS.STEP_AFTER) {
      console.log('OnboardingGuide: Moving to next step', index + 1);
      if (index + 1 < steps.length) {
        setStepIndex(index + 1);
      } else {
        stopGuide();
      }
    } else if (type === EVENTS.TARGET_NOT_FOUND && type !== EVENTS.TOOLTIP) {
      console.log('OnboardingGuide: Target not found, moving to next step');
      if (index + 1 < steps.length) {
        setStepIndex(index + 1);
      } else {
        stopGuide();
      }
    }
  };

  if (!isGuideActive) {
    console.log('OnboardingGuide: Not rendering - guide not active');
    return null;
  }

  console.log('OnboardingGuide: Rendering Joyride with steps:', steps, 'current step:', stepIndex);

  const getButtonText = () => {
    if (stepIndex === steps.length - 1) return 'Terminer';
    return `Étape ${stepIndex + 1}/${steps.length}`;
  };

  return (
    <Joyride
      callback={handleJoyrideCallback}
      continuous
      hideCloseButton
      run={isGuideActive}
      scrollToFirstStep
      showProgress
      showSkipButton
      steps={steps}
      stepIndex={stepIndex}
      styles={{
        options: {
          arrowColor: '#4F46E5',
          backgroundColor: '#4F46E5',
          overlayColor: 'rgba(0, 0, 0, 0.5)',
          primaryColor: '#4F46E5',
          textColor: '#FFFFFF',
          width: 300,
          zIndex: 1000,
        },
        tooltipContainer: {
          textAlign: 'left'
        },
        buttonNext: {
          backgroundColor: '#4F46E5'
        },
        buttonBack: {
          color: '#4F46E5'
        }
      }}
      locale={{
        back: 'Précédent',
        close: 'Fermer',
        last: 'Terminer',
        next: getButtonText(),
        skip: 'Passer',
        open: 'Ouvrir'
      }}
      spotlightPadding={4}
      disableOverlayClose
      floaterProps={{
        disableAnimation: true,
        placement: 'bottom'
      }}
    />
  );
};

export default OnboardingGuide;
